import React from 'react';
import comedora from '../assets/comedora-menu-logo-transparent.png';
import guasasapotv from '../img/gtv.png';
import trincheta from '../img/trincheta.png';
import granada from '../img/granada.png';
import guasasapoSello from '../assets/trincheta-sello-nuevo-transparent.png';
import trinchetaFondo from '../assets/trincheta-fondo.jpg';
import trinchetaMenuLogo from '../assets/trincheta-menu-logo-transparent.png';
import trinchetaCentroNuevo from '../assets/trincheta-centro-nuevo-transparent.png';

const navItems = ['INFO', 'PUBLICACIONES', 'SERVICIOS', 'TIENDA', 'CONTACTO'];

const brandMarks = [
  { src: guasasapoSello, alt: 'Guasasapo', href: '/guasasapo', className: 'trincheta__navBrandMark--guasasapo' },
  { src: comedora, alt: 'Comedora', href: '/comedora' },
  { src: granada, alt: 'Granada', href: '/granada' },
  { src: guasasapotv, alt: 'Guasasapo TV', href: '/guasasapotv' },
];

const Trincheta = () => {
  return (
    <div
      className="trinchetaLanding"
      style={{
        backgroundImage: `linear-gradient(rgba(92, 108, 118, 0.22), rgba(92, 108, 118, 0.22)), linear-gradient(rgba(153, 172, 182, 0.54), rgba(153, 172, 182, 0.54)), url(${trinchetaFondo})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <nav className="trincheta__nav">
        <div className="trincheta__navBrandCluster">
          <a href="/trincheta" className="trincheta__navLogo">
            <img src={trincheta} alt="Trincheta" />
          </a>

          <div className="trincheta__navBrandMenu">
            {brandMarks.map((mark) => (
              <a key={mark.href} href={mark.href} className={`trincheta__navBrandMark ${mark.className || ''}`}>
                <img src={mark.src} alt={mark.alt} />
              </a>
            ))}
          </div>
        </div>

        <div className="trincheta__navRight">
          <ul className="trincheta__navList">
            {navItems.map((item) => (
              <li key={item}>
                <a href={`#${item.toLowerCase()}`} className="trincheta__navLink">
                  {item}
                </a>
              </li>
            ))}
          </ul>

          <img src={trinchetaMenuLogo} alt="Guasasapo Arte y Producción Cooperativa Abierta" className="trincheta__navSupportLogo" />
        </div>
      </nav>

      <main className="trincheta__main">
        <div className="trincheta__hero">
          <div className="trincheta__heroLogo" aria-label="Trincheta">
            <img src={trinchetaCentroNuevo} alt="Trincheta" className="trincheta__heroLogoMain" />
          </div>
          <div className="trincheta__heroDivider" />
          <p className="trincheta__tagline">Producción y publicación editorial</p>
          <p className="trincheta__subtitle">EDICIÓN · DIAGRAMACIÓN · PUBLICACIÓN</p>
        </div>
      </main>

      <footer className="trincheta__footer">
        <span className="trincheta__footerText">TRINCHETA</span>
        <span className="trincheta__footerDot">&middot;</span>
        <span className="trincheta__footerText">COOPERATIVA GUASASAPO</span>
      </footer>
    </div>
  );
};

export default Trincheta;
